import {useContext} from "react";
import {useProject, useProjectId} from "../../ProjectName";
import {PDFInfo, PrintManagerContext} from "../../../../../misc/pdf/PrintManager";
import {distinct} from "nate-react-api-helpers";
import {api} from "../../../../../api/API";
import {DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import {Dialog2} from "../../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../../misc/SmoothActionBar";
import {useSubmittalPreferences} from "../../../../../misc/pdf/useSubmittalPreferences";
import {Project} from "../../../../../api/Projects";
import {Company} from "../../../../../api/Companies";
import {Div10Row} from "../../../../../api/QuoteDiv10";
import {getAll} from "../../../../logistics/routes/useGetAll";
import {Contact} from "../../../../../api/Contacts";
import {useCurrentContractor} from "../../../quote/CurrentContractor";
import {Div10SimplePDF} from "./Div10SimplePDF";

export function MakeSubmittal(props: {
    onDone(): void;
}) {
    const projectId = useProjectId();
    const printCtx = useContext(PrintManagerContext);
    const project = useProject();

    const prefs = useSubmittalPreferences({
        project: projectId,
        kind: "div10",
        onLoad: (list: {}) => {}
    });

    const {getContractorDetails, CurrentContractorPromptElement} = useCurrentContractor({
        onAutoPromptCanceled: props.onDone
    });

    if(CurrentContractorPromptElement) {
        return (<>{CurrentContractorPromptElement}</>);
    }

    if(prefs.loading) return null;

    const submit = async () => {
        await prefs.save({});

        if(!project) return;

        const items = await getAll(null, offset => api.div10.list({
            project: project.id,
            offset: offset,
        }));

        const {client, clientContact} = await getContractorDetails();

        await printCtx.print2(div10PDF({
            lastSubmittal: prefs.lastSubmission,
            project: project,
            client: client,
            clientContact: clientContact,
            items: items,
        }))

        props.onDone();
    };

    return (
        <Dialog2 open maxWidth="md" fullWidth onClose={props.onDone} onEnterPress={submit}>
            <DialogTitle>Create Div 8/10 Cut Sheets Submittal</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    No settings for this submittal
                </DialogContentText>
            </DialogContent>
            <SmoothActionBar
                actionName="Create and Download"
                onCancel={props.onDone}
                onSubmit={submit}
            />
        </Dialog2>
    )
}

export function div10PDF(props: {
    project: Project
    client?: Company
    clientContact?: Contact
    lastSubmittal: string | null;
    items: Div10Row[];
}): PDFInfo {

    return {
        name: `div-10-cut-sheets.pdf`,
        render: async onReady => <Div10SimplePDF
            lastSubmittal={props.lastSubmittal}
            project={props.project}
            client={props.client}
            clientContact={props.clientContact}
            onReady={onReady} />,
        serverInfo: {
            submissionForProject: props.project.id,
            submissionType: "div10",
            appendCatalogPagesForProducts: distinct(props.items.map(i => i.product).filter(i => !!i)),
        }
    }
}